import axios from "axios";
import { rollbarConfig } from "lib/rollbarConfig";
import Rollbar from "rollbar";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const contentful = require("contentful");

export const apiFlickClient = axios.create({
  baseURL: process.env.REACT_APP_FLICK_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
});

export const rollbar = new Rollbar(rollbarConfig);
apiFlickClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestURL = error.response.config.url;
    const requestData = error.response.config.data;
    const requestError = Array.isArray(error.response.data.errors)
      ? error.response.data.errors.length > 0
        ? JSON.stringify(error.response.data.errors)
        : "Undefined error"
      : error.response.data.errors ?? "Undefined error";

    if (requestURL.includes("/customer/nz/sign_ups")) {
      const customerICPOrEmail =
        JSON.parse(requestData)["ea_icp_id"] ??
        JSON.parse(requestData)["email"];
      const errorTitle = `AxiosError: ${customerICPOrEmail} signup failure`;
      const isPromoCodeError = JSON.stringify(requestError).includes(
        "Promotional code The promotion code you have entered is not valid",
      );

      isPromoCodeError
        ? rollbar.info("Customer using invalid promo code", {
            customerDetails: customerICPOrEmail,
            requestError,
            data: JSON.stringify(requestData),
          })
        : rollbar.error(errorTitle, requestError, JSON.stringify(requestData));
    } else {
      rollbar.error(
        `AxiosError: ${requestURL} calls failure`,
        requestError,
        JSON.stringify(requestData),
      );
    }
    return Promise.reject(error);
  },
);

export const contentfulFlickClient = axios.create({
  baseURL: `https://graphql.contentful.com`,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN}`,
  },
});

export const contentfulApi = contentful.createClient({
  space: process.env.REACT_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN,
});
